import $ from 'jquery';
import { getState } from '~src/state';

export function updateTextBorderColorControl() {
  let strokeColor;
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      strokeColor = activeObject.get('stroke');
    } else if (selectionStart === selectionEnd) {
      strokeColor = activeObject.get('stroke');
    } else {
      const selectionStyles = activeObject.getSelectionStyles();
      if (selectionStyles && selectionStyles.length > 0 && selectionStyles[0]) {
        strokeColor =
          selectionStyles[0]['stroke'] || activeObject.get('stroke');
      } else {
        strokeColor = activeObject.get('stroke');
      }
    }
  } else {
    strokeColor = activeObject.get('stroke');
  }

  $('#color-text-border').css('background-color', strokeColor || 'transparent');

  // Update main button appearance based on border state
  const $mainButton = $('#color-text-border-main');
  if (strokeColor && strokeColor !== 'transparent' && strokeColor !== null) {
    $mainButton.addClass('active').css('border-color', strokeColor);
  } else {
    $mainButton.removeClass('active').css('border-color', '#ccc');
  }
}
